/**
 * Responsive background images
 *
 * Usage in HTML:
 *
 * Add the data-responsive-background-image attribute to the container element of an image:
 * <div data-responsive-background-image>
 *     <img src="" srcset="" sizes="" alt="" />
 * </div>
 *
 * Don't forget to add CSS styles
 */
import PubSub from 'pubsub-js';

class ResponsiveBackgroundImage {

    constructor(element) {
        this.element = element;
        this.img = element.querySelector('img');
        this.src = '';

        if (this.img) {
            this.img.addEventListener('load', () => {
                this.update();
            });

            if (this.img.complete || this.img.width + this.img.height > 0) {
                this.update(true);
            }

            // signify that the background image has completed lazyloading
            this.img.addEventListener('lazybeforeunveil', () => {
                this.element.classList.add('is-lazyloaded');
            });
        }
    }

    update(cached= false) {
        let src = this.img.currentSrc || this.img.src;
        if (this.src !== src) {
            this.src = src;
            this.element.style.backgroundImage = 'url("' + this.src + '")';

            // signify that the background image has loaded
            this.element.classList.add('is-loaded');

            if (cached) {
                // signify that the image came from cache
                this.element.classList.add('is-cached');
            }
        }
    }
}

function debounce(func, time){
    time = time || 100; // 100 by default if no param
    let timer;
    return function(event){
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}

let elements = document.querySelectorAll('[data-responsive-background-image]');
for (let i=0; i<elements.length; i++) {
    new ResponsiveBackgroundImage(elements[i]);
}


let loadBgImages = function (msg, id) {
    let elements = document.querySelectorAll('#' + id + ' [data-responsive-background-image]');

    for (let i=0; i<elements.length; i++) {
        new ResponsiveBackgroundImage(elements[i]);
    }
};

let loadBgImagesRellax = function () {
    let elements = document.querySelectorAll('.rellax[data-responsive-background-image]');

    for (let i=0; i<elements.length; i++) {
        new ResponsiveBackgroundImage(elements[i]);
    }
};

PubSub.subscribe('tabOnLoaded', loadBgImages);
PubSub.subscribe('resizeDone', loadBgImagesRellax);